import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { CampaignsBannerComponent } from '@pages/campaigns/campaigns-banner/campaigns-banner.component';
import { CampaignsDatatableComponent } from '@pages/campaigns/campaigns-datatable/campaigns-datatable.component';
import { CampaignsStore } from '@pages/campaigns/campaigns.store';
import { ContentContainerComponent } from '@shared/components/content-container/content-container.component';
import { IDataRefreshRequestParams } from '@shared/components/datatable/datatable.interface';
import { DotsSpinnerComponent } from '@shared/components/dots-spinner/dots-spinner.component';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { CampaignsDatatableService } from '../../campaigns/campaigns-datatable/campaigns-datatable.service';

@Component({
  imports: [
    FormsModule,
    CampaignsDatatableComponent,
    CampaignsBannerComponent,
    ContentContainerComponent,
    MatFormFieldModule,
    NgxSkeletonLoaderComponent,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
    DotsSpinnerComponent,
  ],
  providers: [CampaignsStore],
  selector: 'app-admin-campaigns',
  templateUrl: './admin-campaigns.component.html',
})
export class AdminCampaignsComponent {
  public readonly campaignsStore = inject(CampaignsStore);
  public readonly campaignsDatatableService = inject(CampaignsDatatableService);

  public readonly searchedOnce = signal(false);

  public adminSearchId = '';
  public adminSearchName = '';

  private datatableParams: IDataRefreshRequestParams | null = null;

  public onAdminSearch(): void {
    this.searchedOnce.set(true);

    this.campaignsStore.fetchCampaigns({
      ...(this.datatableParams
        ? this.campaignsDatatableService.prepareFetchCampaignsParams({
            params: {
              ...this.datatableParams,
              page: this.adminSearchName || this.adminSearchId ? 0 : this.datatableParams.page,
            },
          })
        : {}),
      adminMode: true,
      campaignId: this.adminSearchId || undefined,
      campaignName: this.adminSearchName || undefined,
    });
  }

  public onDataRefreshRequest(params: IDataRefreshRequestParams): void {
    this.datatableParams = params;
  }
}
